import React from 'react';
import PageMenu from '../components/menu/PageMenu';

const MenuPage = (props) => {
    const {children, title, onBackClick, menu} = props;
    return (
        <div className="menuPageContainer">
            <PageMenu title={title} onBackClick={onBackClick} menu={menu}/>
            {children}
        </div>
    )
};



export default MenuPage;

export const MenuPageHoc = Component => props =>
    <MenuPage {...props}>
        <Component {...props} />
    </MenuPage>



// WEBPACK FOOTER //
// ./src/pages/MenuPage.js